import zod from "zod";

export const ownerSchema = zod.object({
  id: zod.number(),
  full_name: zod.string(),
});
